type Props = {
    time: string;
};

type ReturnType = {
    endHours: string;
    startHours: string;
};

export const getPreparedTime = ({ time }: Props): ReturnType => {
    if (!time) {
        return {
            startHours: '10:00',
            endHours: '18:00',
        };
    }

    const splittedTime = time.split('-').map((el) => el.replace(' ', ''));

    return {
        startHours: splittedTime[0],
        endHours: splittedTime[1],
    };
};
